import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CognitoService } from '../services/cognito.service';
import { UserRoles } from '../models/user-roles.enum';

@Injectable({
  providedIn: 'root'
})
export class RootRedirectGuard implements CanActivate {
  
  constructor(
    private cognitoService: CognitoService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      const isAuthenticated = await this.cognitoService.isAuthenticated();
      
      if (!isAuthenticated) {
        this.router.navigate(['/signin']);
        return false;
      }

      const user = await this.cognitoService.getUser();
      
      if (user.role === UserRoles.PENDING_USER) {
        this.router.navigate(['/signin']);
        return false;
      }

      this.router.navigate(['/app']);
      return false;
      
    } catch (error) {
      this.router.navigate(['/signin']);
      return false;
    }
  }
}
